import React from 'react';

import classes from 'src/components/AtbModal/AddToBasketModal.scss';
import { Button } from 'src/components/Button/Button';
import { Svg } from 'src/components/Svg/Svg';

import type { ModalEventProps } from '../types';

export type AddToBasketModalHeaderProps = Pick<ModalEventProps, 'onClose'>;

export const AddToBasketModalHeader = (props: AddToBasketModalHeaderProps) => {
    return (
        <div className={classes['addToBasketModalHeader']}>
            <p className={classes['addToBasketModalTitle']} data-test-id="ModalHeader_title" id="atb_modal_label">
                Added to Cart
            </p>
            <Button
                onClick={() => props.onClose?.()}
                variant="reset"
                className={classes['addToBasketModalCloseButton']}
                aria-label="Close successful add to basket popup"
            >
                <Svg name="close" aria-hidden="true" />
            </Button>
        </div>
    );
};

export default AddToBasketModalHeader;
